var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"name"},[_c('span',{staticClass:"circle"}),_vm._v("\n  "+_vm._s(_vm.name)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }